export default "__VITE_ASSET__b1c17523__"